// lib/auth.ts
import { Auth0Client, createAuth0Client } from "@auth0/auth0-spa-js";
import { getPublicEnv } from '@/utils/env';

let client: Auth0Client | null = null;

/**
 * Initializes or retrieves the Auth0 client.
 *
 * This ensures the Auth0 client is only created once (singleton pattern)
 * and dynamically configures locale-based login UI.
 */
export const getAuth0Client = async () => {
  const pathname = globalThis.location.pathname;
  const locale = pathname.split("/")[1] || "ja";

  client ??= await createAuth0Client({
    domain: getPublicEnv('NEXT_PUBLIC_CLIENT_DOMAIN') ?? "id.gotopass.jp",
    clientId: getPublicEnv('NEXT_PUBLIC_AUTH0_CLIENT_ID') ?? "",
    authorizationParams: {
      redirect_uri:
        globalThis.window === undefined
          ? getPublicEnv('NEXT_PUBLIC_BASE_URL')
          : globalThis.location.origin,
      audience: getPublicEnv('NEXT_PUBLIC_AUDIENCE'),
      entity_type: "STORE_CODE",
      entity_code: getPublicEnv('NEXT_PUBLIC_ENTITY_CODE'),
      entity_source: "API",
      ui_locales: locale === "en-us" ? "en" : "ja",
      acquisition_channel: "Mystays Website",
      screen_hint: "login",
      response_type: "code",
      scope: "openid profile email offline_access",
    },
    cacheLocation: "localstorage",
    useRefreshTokens: true,
  });

  return client;
};
